module.exports = __webpack_public_path__ + "media/images/parking privé payant-8ff45ed3d982329b3c88a824bc020bb6.svg";